import ReactDOM from 'react-dom'

function ConfirmModal({ open, onClose, onConfirm, isLoading, error }) {
    if (!open) return null;

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[150] bg-black/20 flex items-center justify-center"
            onClick={onClose}
        >
            <div
                className="relative w-[360px] rounded-[16px] bg-[#f8fef4] px-8 pt-[72px] pb-[48px] flex flex-col items-center"
                onClick={e => e.stopPropagation()}
            >
                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute top-[16px] right-[16px] flex items-center justify-center w-6 h-6 text-brand-muted hover:text-brand-dark transition-colors"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </button>

                <p className="text-[14px] text-brand-dark mb-[32px]">
                    Are you sure you want to delete?
                </p>

                <button
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="px-[24px] py-[8px] rounded-[48px] bg-[#D85263] text-white text-[14px] font-semibold hover:bg-[#E86575] disabled:opacity-60"
                >
                    {isLoading ? 'Deleting…' : 'Delete'}
                </button>

                {error && (
                    <p className="mt-3 text-[12px] text-red-500 text-center">{error}</p>
                )}
            </div>
        </div>,
        document.getElementById('portal')
    )
}

export default ConfirmModal
